// extracted by mini-css-extract-plugin
module.exports = {"carouselLayout":"Carousel_carouselLayout__2Cpv-","carouselLayoutp":"Carousel_carouselLayoutp__2tNHw","InfinitecarouselLayout":"Carousel_InfinitecarouselLayout__2Brna"};